import { useCallback, useEffect, useState } from 'react';

import { useAikoSupport } from '@/components/composite/SparksAgent/hooks/useAikoSupport';

import { STORAGE_KEY_OPEN } from '@/components/composite/SparksAgent/const';

type UseSparksAgentShellOptions = {
    /** Runs when the user minimizes Sparks (before persisting closed state). */
    onMinimize?: () => void;
};

export function useSparksAgentShell(options: UseSparksAgentShellOptions = {}) {
    const { onMinimize } = options;

    const [isOpen, setIsOpen] = useState(false);

    const handleMinimize = useCallback(() => {
        onMinimize?.();
        setIsOpen(false);
        try {
            localStorage.setItem(STORAGE_KEY_OPEN, 'false');
        } catch {
            /* noop */
        }
    }, [onMinimize]);

    const { onNeedSupportClick, isAikoOpen } = useAikoSupport({ onBeforeOpen: handleMinimize });

    const handleOpen = useCallback(() => {
        setIsOpen(true);
        try {
            localStorage.setItem(STORAGE_KEY_OPEN, 'true');
        } catch {
            /* noop */
        }
    }, []);

    useEffect(() => {
        try {
            const storedOpen = localStorage.getItem(STORAGE_KEY_OPEN);
            if (storedOpen !== null) setIsOpen(storedOpen === 'true');
        } catch {
            /* localStorage unavailable */
        }
    }, []);

    return {
        isOpen,
        isAikoOpen,
        handleOpen,
        handleMinimize,
        onNeedSupportClick
    };
}
